import React from 'react';

const ArrowRightIcon = () => (
  <svg
    width='7'
    height='13'
    viewBox='0 0 7 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.5306 7.0306L1.5306 12.0306C1.3897 12.1715 1.19861 12.2506 0.999348 12.2506C0.80009 12.2506 0.608994 12.1715 0.468098 12.0306C0.327201 11.8897 0.248047 11.6986 0.248047 11.4993C0.248047 11.3001 0.327201 11.109 0.468098 10.9681L4.93747 6.49997L0.469348 2.0306C0.399583 1.96083 0.344243 1.87801 0.306486 1.78686C0.26873 1.69571 0.249297 1.59801 0.249297 1.49935C0.249297 1.40069 0.26873 1.30299 0.306486 1.21184C0.344243 1.12069 0.399583 1.03786 0.469348 0.968098C0.539113 0.898333 0.621936 0.842993 0.713088 0.805236C0.80424 0.76748 0.901936 0.748047 1.0006 0.748047C1.09926 0.748047 1.19696 0.76748 1.28811 0.805236C1.37926 0.842993 1.46208 0.898333 1.53185 0.968098L6.53185 5.9681C6.60169 6.03786 6.65707 6.12072 6.69481 6.21193C6.73256 6.30313 6.75193 6.4009 6.75182 6.49961C6.7517 6.59832 6.7321 6.69604 6.69414 6.78715C6.65618 6.87827 6.6006 6.961 6.5306 7.0306Z'
      fill='#D3D3D3'
    />
  </svg>
);

export default ArrowRightIcon;
